import { createSlice } from "@reduxjs/toolkit";

const initialScroll = {
  opacity: 0,
  x: 0,
  LandingHeight: 0,
  DepartmentsHeight: 0,
  OurWorkHeight: 0,
  MapHeight: 0,
  FactsHeight: 0,
  FooterHeight:0,
};

const ScrollSlice = createSlice({
  name: "scroll",
  initialState: initialScroll,
  reducers: {
    UpdateLanding(state, action) {
      state.LandingHeight = action.payload;
    },
    UpdateDepartments(state, action) {
      state.DepartmentsHeight = action.payload;
    },
    UpdateOurWork(state, action) {
      state.OurWorkHeight = action.payload;
    },
    UpdateMap(state, action) {
      state.MapHeight = action.payload;
    },
    UpdateFacts(state, action) {
      state.FactsHeight = action.payload;
    },
    UpdateFooter(state, action) {
      state.FooterHeight = action.payload;
    },
    updateOpacity(state,action){
      state.opacity = action.payload.opacity;
      state.x = action.payload.x;
    },
    setInitial(state){
      state = {
        opacity: 0,
        x: 0,
        LandingHeight: 0,
        DepartmentsHeight: 0,
        OurWorkHeight: 0,
        MapHeight: 0,
        FactsHeight: 0,
        FooterHeight:0,
      };
    }
  },
});

export const ScrollActions = ScrollSlice.actions;
export default ScrollSlice.reducer;
